import { useState, useEffect, useCallback, useContext } from "react";
import { AuthContext } from "../contexts";
import { VEBPlanName } from "../types/plan.types";
import { getVEBEmployeeEligiblity } from "../utils/commonFunctions/VEBEnrollment/eligibleEmployee";

const useEmployeeVEBEligiblity = (VEBPlanName: VEBPlanName) => {
	const { member } = useContext(AuthContext);
	const [isEligible, setIsEligible] = useState<boolean | null>(null);
	const [eligiblityMessage, setEligiblityMessage] = useState<string>("");

	const _getVEBEmployeeEligiblity = useCallback(() => {
		if (member) {
			const { isEligible, eligiblityMessage } = getVEBEmployeeEligiblity(VEBPlanName, member);
			setIsEligible(isEligible);
			setEligiblityMessage(eligiblityMessage);
		}
	}, [VEBPlanName, member]);

	useEffect(() => {
		_getVEBEmployeeEligiblity();
	}, [_getVEBEmployeeEligiblity]);

	return {
		isEligible,
		eligiblityMessage
	};
};

export default useEmployeeVEBEligiblity;
